/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as CoursesRouteImport } from './routes/courses'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TestIndexRouteImport } from './routes/test/index'
import { Route as OrderIndexRouteImport } from './routes/order.index'
import { Route as TestTokenLoginRouteImport } from './routes/test/token-login'
import { Route as TestManualLoginRouteImport } from './routes/test/manual-login'
import { Route as TestClickErrorRouteImport } from './routes/test/click-error'
import { Route as OrderOrderIdRouteImport } from './routes/order.$orderId'
import { Route as TestSignIdRouteImport } from './routes/test/sign.$id'
import { Route as EnrollInputtingCourse_idRouteImport } from './routes/enroll.inputting.$course_id'
import { Route as CourseDetailIdRouteImport } from './routes/course.detail.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const GuideRoute = GuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const FavoritesRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const CoursesRoute = CoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestIndexRoute = TestIndexRouteImport.update({
  id: '/test/',
  path: '/test/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderIndexRoute = OrderIndexRouteImport.update({
  id: '/order/',
  path: '/order/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestTokenLoginRoute = TestTokenLoginRouteImport.update({
  id: '/test/token-login',
  path: '/test/token-login',
  getParentRoute: () => rootRouteImport,
} as any)
const TestManualLoginRoute = TestManualLoginRouteImport.update({
  id: '/test/manual-login',
  path: '/test/manual-login',
  getParentRoute: () => rootRouteImport,
} as any)
const TestClickErrorRoute = TestClickErrorRouteImport.update({
  id: '/test/click-error',
  path: '/test/click-error',
  getParentRoute: () => rootRouteImport,
} as any)
const OrderOrderIdRoute = OrderOrderIdRouteImport.update({
  id: '/order/$orderId',
  path: '/order/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSignIdRoute = TestSignIdRouteImport.update({
  id: '/test/sign/$id',
  path: '/test/sign/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EnrollInputtingCourse_idRoute =
  EnrollInputtingCourse_idRouteImport.update({
    id: '/enroll/inputting/$course_id',
    path: '/enroll/inputting/$course_id',
    getParentRoute: () => rootRouteImport,
  } as any)
const CourseDetailIdRoute = CourseDetailIdRouteImport.update({
  id: '/course/detail/$id',
  path: '/course/detail/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/courses': typeof CoursesRoute
  '/favorites': typeof FavoritesRoute
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/test/click-error': typeof TestClickErrorRoute
  '/test/manual-login': typeof TestManualLoginRoute
  '/test/token-login': typeof TestTokenLoginRoute
  '/order': typeof OrderIndexRoute
  '/test': typeof TestIndexRoute
  '/course/detail/$id': typeof CourseDetailIdRoute
  '/enroll/inputting/$course_id': typeof EnrollInputtingCourse_idRoute
  '/test/sign/$id': typeof TestSignIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/courses': typeof CoursesRoute
  '/favorites': typeof FavoritesRoute
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/test/click-error': typeof TestClickErrorRoute
  '/test/manual-login': typeof TestManualLoginRoute
  '/test/token-login': typeof TestTokenLoginRoute
  '/order': typeof OrderIndexRoute
  '/test': typeof TestIndexRoute
  '/course/detail/$id': typeof CourseDetailIdRoute
  '/enroll/inputting/$course_id': typeof EnrollInputtingCourse_idRoute
  '/test/sign/$id': typeof TestSignIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/courses': typeof CoursesRoute
  '/favorites': typeof FavoritesRoute
  '/guide': typeof GuideRoute
  '/login': typeof LoginRoute
  '/order/$orderId': typeof OrderOrderIdRoute
  '/test/click-error': typeof TestClickErrorRoute
  '/test/manual-login': typeof TestManualLoginRoute
  '/test/token-login': typeof TestTokenLoginRoute
  '/order/': typeof OrderIndexRoute
  '/test/': typeof TestIndexRoute
  '/course/detail/$id': typeof CourseDetailIdRoute
  '/enroll/inputting/$course_id': typeof EnrollInputtingCourse_idRoute
  '/test/sign/$id': typeof TestSignIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/courses'
    | '/favorites'
    | '/guide'
    | '/login'
    | '/order/$orderId'
    | '/test/click-error'
    | '/test/manual-login'
    | '/test/token-login'
    | '/order'
    | '/test'
    | '/course/detail/$id'
    | '/enroll/inputting/$course_id'
    | '/test/sign/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/courses'
    | '/favorites'
    | '/guide'
    | '/login'
    | '/order/$orderId'
    | '/test/click-error'
    | '/test/manual-login'
    | '/test/token-login'
    | '/order'
    | '/test'
    | '/course/detail/$id'
    | '/enroll/inputting/$course_id'
    | '/test/sign/$id'
  id:
    | '__root__'
    | '/'
    | '/courses'
    | '/favorites'
    | '/guide'
    | '/login'
    | '/order/$orderId'
    | '/test/click-error'
    | '/test/manual-login'
    | '/test/token-login'
    | '/order/'
    | '/test/'
    | '/course/detail/$id'
    | '/enroll/inputting/$course_id'
    | '/test/sign/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CoursesRoute: typeof CoursesRoute
  FavoritesRoute: typeof FavoritesRoute
  GuideRoute: typeof GuideRoute
  LoginRoute: typeof LoginRoute
  OrderOrderIdRoute: typeof OrderOrderIdRoute
  TestClickErrorRoute: typeof TestClickErrorRoute
  TestManualLoginRoute: typeof TestManualLoginRoute
  TestTokenLoginRoute: typeof TestTokenLoginRoute
  OrderIndexRoute: typeof OrderIndexRoute
  TestIndexRoute: typeof TestIndexRoute
  CourseDetailIdRoute: typeof CourseDetailIdRoute
  EnrollInputtingCourse_idRoute: typeof EnrollInputtingCourse_idRoute
  TestSignIdRoute: typeof TestSignIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guide': {
      id: '/guide'
      path: '/guide'
      fullPath: '/guide'
      preLoaderRoute: typeof GuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/courses': {
      id: '/courses'
      path: '/courses'
      fullPath: '/courses'
      preLoaderRoute: typeof CoursesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/': {
      id: '/test/'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/': {
      id: '/order/'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof OrderIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/token-login': {
      id: '/test/token-login'
      path: '/test/token-login'
      fullPath: '/test/token-login'
      preLoaderRoute: typeof TestTokenLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/manual-login': {
      id: '/test/manual-login'
      path: '/test/manual-login'
      fullPath: '/test/manual-login'
      preLoaderRoute: typeof TestManualLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/click-error': {
      id: '/test/click-error'
      path: '/test/click-error'
      fullPath: '/test/click-error'
      preLoaderRoute: typeof TestClickErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/order/$orderId': {
      id: '/order/$orderId'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof OrderOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/sign/$id': {
      id: '/test/sign/$id'
      path: '/test/sign/$id'
      fullPath: '/test/sign/$id'
      preLoaderRoute: typeof TestSignIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/enroll/inputting/$course_id': {
      id: '/enroll/inputting/$course_id'
      path: '/enroll/inputting/$course_id'
      fullPath: '/enroll/inputting/$course_id'
      preLoaderRoute: typeof EnrollInputtingCourse_idRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/course/detail/$id': {
      id: '/course/detail/$id'
      path: '/course/detail/$id'
      fullPath: '/course/detail/$id'
      preLoaderRoute: typeof CourseDetailIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CoursesRoute: CoursesRoute,
  FavoritesRoute: FavoritesRoute,
  GuideRoute: GuideRoute,
  LoginRoute: LoginRoute,
  OrderOrderIdRoute: OrderOrderIdRoute,
  TestClickErrorRoute: TestClickErrorRoute,
  TestManualLoginRoute: TestManualLoginRoute,
  TestTokenLoginRoute: TestTokenLoginRoute,
  OrderIndexRoute: OrderIndexRoute,
  TestIndexRoute: TestIndexRoute,
  CourseDetailIdRoute: CourseDetailIdRoute,
  EnrollInputtingCourse_idRoute: EnrollInputtingCourse_idRoute,
  TestSignIdRoute: TestSignIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
